var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileDevAndriod(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.024,
    height: 196.701,
    viewBox: "0 0 92.024 196.701",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9801",
    "data-name": "Group 9801",
    transform: "translate(-105.104 -25.264)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2131",
    "data-name": "Rectangle 2131",
    width: 2.013,
    height: 28.47,
    transform: "translate(105.104 53.159)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2132",
    "data-name": "Rectangle 2132",
    width: 2.013,
    height: 16.104,
    transform: "translate(105.104 91.406)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2133",
    "data-name": "Rectangle 2133",
    width: 90.586,
    height: 196.701,
    rx: 12,
    transform: "translate(106.542 25.264)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2134",
    "data-name": "Rectangle 2134",
    width: 90.586,
    height: 179.159,
    rx: 7,
    transform: "translate(106.542 34.466)",
    fill: "#717c91"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2135",
    "data-name": "Rectangle 2135",
    width: 14.954,
    height: 2.013,
    rx: 1.007,
    transform: "translate(144.502 29.577)",
    fill: "#eaeaf3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_297",
    "data-name": "Ellipse 297",
    cx: 1.438,
    cy: 1.438,
    r: 1.438,
    transform: "translate(163.195 29.29)",
    fill: "#eaeaf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10335",
    "data-name": "Path 10335",
    d: "M471.878,364.683v20.993a4.966,4.966,0,0,1-4.984,5.021c-2.772,0-5.464-2.246-5.464-5.021V364.683c0-2.738,2.683-4.984,5.464-4.984A5,5,0,0,1,471.878,364.683Zm1.958,28.453A5.352,5.352,0,0,0,479.2,398.5h3.606l.055,11.074c0,6.686,10,6.634,10,0V398.5h6.741v11.074c0,6.652,10.065,6.669,10.065,0V398.5h3.661a5.346,5.346,0,0,0,5.329-5.363V360.614H473.836Zm44.945-34.27H473.632c0-7.764,4.639-14.5,11.526-18.014l-3.451-6.4c-.506-.889.779-1.438,1.214-.687l3.517,6.453a24.484,24.484,0,0,1,19.627,0l3.5-6.433a.7.7,0,1,1,1.214.687l-3.451,6.378A20.425,20.425,0,0,1,518.781,358.865ZM487.844,348.8a1.9,1.9,0,1,0,0,.006Zm20.553,0a1.891,1.891,0,1,0,0,.006Zm17.18,10.893a4.969,4.969,0,0,0-4.984,4.984V385.67a5,5,0,0,0,4.984,5.021c2.792,0,5.464-2.246,5.464-5.021V364.677c-.009-2.784-2.692-4.978-5.464-4.978Z",
    transform: "translate(-343.537 -250.788)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2136",
    "data-name": "Rectangle 2136",
    width: 18.692,
    height: 0.863,
    transform: "translate(130.555 163.748)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2137",
    "data-name": "Rectangle 2137",
    width: 12.366,
    height: 0.863,
    transform: "translate(156.149 163.748)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2138",
    "data-name": "Rectangle 2138",
    width: 12.366,
    height: 0.863,
    transform: "translate(114.163 163.748)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2139",
    "data-name": "Rectangle 2139",
    width: 12.366,
    height: 0.863,
    transform: "translate(175.704 163.748)",
    fill: "#535461"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileDevAndriod);
export default __webpack_public_path__ + "static/media/mobile-dev-andriod.777d0e49c20418f9756996f57d16184b.svg";
export { ForwardRef as ReactComponent };